module.exports = __webpack_public_path__ + "img/c7e3f09d4c7843e7b99ab2fad836587d.png";